//
//
//
//

export default {
  name: "checkbox-defaultValue-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};